import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {InteractiveTable} from 'main/components';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {NmbrPayStub} from 'main/stores/nmbr';

const ViewFileButton = observer(({model}) => {
  return (
    <a
      className='TextLink dodger'
      href={`/api${endpoints.NMBR.PAY_STUB.with(model.id)}`}
      target='_blank' rel='noreferrer'
    >
      <FormattedMessage id='employees.profile.banking.View File'/>
    </a>
  );
});

const COLUMNS = [
  {
    header: 'employees.profile.banking.Pay Period',
    width: 10,
    attribute: 'dateRange'
  },
  {
    width: 2,
    className: 'right-align',
    component: ViewFileButton
  }
];

const NmbrPayStubsTable = observer(({employee}) => {
  return (
    <InteractiveTable
      title={t('employees.profile.banking.Pay Stubs')}
      columns={COLUMNS}
      showLinks={false}
      searchable={false}
      sortable={false}
      proxy={{
        type: 'async',
        modelType: types.NMBR.PAY_STUB,
        model: NmbrPayStub,
        endpoint: endpoints.NMBR.PAY_STUBS.with(employee.id),
        pageSize: 15
      }}
    />
  );
});

export default NmbrPayStubsTable;
